<svg
  class="brand__logo"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 93.0966 134.4143"
>
  <radialGradient
    id="radial-gradient"
    cx="74.2725"
    cy="258.0238"
    r="42.5697"
    gradientTransform="matrix(0.9999, 0.0144, -0.0028, 0.1943, 0.7274, 206.8273)"
    gradientUnits="userSpaceOnUse"
  >
    <stop offset="0.0114" stop-color="#3ed178" />
    <stop offset="0.9525" stop-color="#00a88e" />
  </radialGradient>
  <linearGradient
    id="snake-gradient-middle"
    x1="58.8707"
    y1="325.372"
    x2="91.955"
    y2="325.372"
    gradientUnits="userSpaceOnUse"
  >
    <stop offset="0.0028" stop-color="#00aa8b" />
    <stop offset="0.257" stop-color="#007dbf" />
    <stop offset="0.4958" stop-color="#17569e" />
    <stop offset="0.7347" stop-color="#2a3582" />
    <stop offset="0.8659" stop-color="#312978" />
  </linearGradient>
  <linearGradient
    id="snake-gradient-bottom"
    x1="38.5302"
    y1="346.9538"
    x2="97.0169"
    y2="346.9538"
    xlink:href="#snake-gradient-middle"
  ></linearGradient>
  <linearGradient
    id="snake-gradient-top"
    x1="55.5614"
    y1="270.18"
    x2="129.0149"
    y2="270.18"
    xlink:href="#snake-gradient-bottom"
  ></linearGradient>
  <g id="Stem">
    <path
      class="stem"
      d="M80.8656,319.4214c-3.9036.87-8.1374.8162-12.0335,1.4891l.0065-5.54.0151-12.7021.0021-1.75a20.3623,20.3623,0,0,1,3.4541-.9391c2.9308-.2884,5.7757-.4937,8.5557-.7506v20.1933Zm12.2025,33.6173c-.127-.2291-.3225-.5862-.5554-1.0324L74.8886,354.21l-8.3261-1.0409c5.0424.6695,17.4743,1.7181,22.2746-5.1447a9.7914,9.7914,0,0,0,.5763-.9306c-.6592-1.3881-1.2228-2.5109-1.6105-3.27-1.4548-2.8487-2.8013-5.2153-4.7756-8.8908l-.1765-.3286-1.9852-3.696v-2.9469c-2.1336.25-4.3826.7074-6.7959,1.0408a16.9122,16.9122,0,0,0-5.251,1.1463l-.0014.87-.434.8079-3.97,7.3915-7.8994,14.7064.0889-.0039a11.1224,11.1224,0,0,0-1.3388,3.4007h0c0,.44,2.96.6872,5.3452.8862,2.2043.1839,6.8462.4286,16.7686.2866l0-.0025c6.8025.0191,10.3106-.175,12.1386-.3275,2.3853-.199,5.3449-.4459,5.3452-.8862h0C94.8611,356.2517,93.3365,353.523,93.0681,353.0387Z"
      transform="translate(-35.9183 -224.122)"
    />
  </g>
  <g id="Shadows">
    <path
      id="_1"
      data-name=" 1"
      class="shadows"
      d="M62.6169,357.88c-.302-.0234-1.786-.1532-1.7864-.1532H60.83a7.873,7.873,0,0,1-2.5923-.676l32.6809-8.2891,2.7637,5.422a35.38,35.38,0,0,1-3.809,1.2976,36.1338,36.1338,0,0,1-3.5321.7912c-3.7279.659-11.26,2.1672-17.8415,1.8885C64.5657,357.9937,63.0935,357.9166,62.6169,357.88Z"
      transform="translate(-35.9183 -224.122)"
    />
    <path
      class="shadows"
      d="M80.8656,291.7872a2.4666,2.4666,0,0,1,.0954-.7248c.3633-1.2522,1.58-1.5673,1.56-1.8879-.0745-1.148-15.9407-1.1013-16.006.1642-.0194.3758,1.3692.5731,2.0382,1.98a3.4685,3.4685,0,0,1,.3189,1.5426Z"
      transform="translate(-35.9183 -224.122)"
    />
    <path
      id="_2"
      data-name=" 2"
      class="shadows"
      d="M80.8654,330.6974l.0028-6.686-13.216,2.5431.1363,6.6708a45.5485,45.5485,0,0,1,4.9533-1.4356A44.7435,44.7435,0,0,1,80.8654,330.6974Z"
      transform="translate(-35.9183 -224.122)"
    />
    <path
      id="_3"
      data-name=" 3"
      class="shadows"
      d="M68.9005,305.5115a29.1726,29.1726,0,0,1,3.3885-.6491c1.3059-.1714,2.1091-.1882,4.7711-.3316.891-.048,2.2007-.1215,3.8055-.2229v-6.21l-11.994,1.1643Q68.886,302.387,68.9005,305.5115Z"
      transform="translate(-35.9183 -224.122)"
    />
  </g>
  <g id="outer-cup">
    <path
      class="stem"
      d="M112.7182,252.0022q-.5526.0381-1.1115.0752t-1.1233.0737q-.5643.0366-1.1347.0722t-1.1464.07q-.5757.0348-1.1573.0685t-1.1687.0667q-.587.033-1.18.0647t-1.1906.0625q-.5979.0308-1.2013.06t-1.2121.0579q-.6089.0282-1.2228.0554t-1.2331.0527q-.6187.0257-1.2432.05T96.14,252.88q-.6294.0229-1.2635.0443t-1.2732.0412q-.6392.02-1.2828.0381-.6054.0174-1.2081.0327t-1.2025.03q-.6.0139-1.1969.0261t-1.1908.023q-.5943.0106-1.1851.02t-1.1788.0167q-.5877.0077-1.1726.0135t-1.1661.0105q-.5817.0043-1.1595.0074t-1.1527.0045q-.5747.0014-1.1458.0015t-1.1387-.0012q-.5676-.0014-1.1317-.0041t-1.1244-.0069q-.56-.004-1.117-.0095l-.0417-.0039c-.0761.0009-.1543.0018-.23.0018s-.1536-.0008-.23-.0016l-.042.0038q-.5535.0055-1.1106.01t-1.1176.007q-.5609.0028-1.125.0044t-1.1323.0014q-.5679,0-1.1391-.0014t-1.1461-.0044q-.5746-.0028-1.1526-.0074t-1.1593-.01q-.5811-.0059-1.1657-.0133t-1.1719-.0166q-.5876-.009-1.1781-.02t-1.184-.023q-.5934-.012-1.19-.026t-1.1955-.0293q-.5991-.0156-1.2009-.0327-.64-.0181-1.2764-.038t-1.2669-.0413q-.6309-.0213-1.257-.0442t-1.2471-.0473q-.621-.0245-1.2371-.05t-1.2269-.0528q-.6106-.0272-1.2164-.0555t-1.206-.0579q-.6-.03-1.1953-.06t-1.1847-.0626q-.59-.0319-1.1735-.0648t-1.1628-.067q-.5784-.0339-1.1515-.0687t-1.14-.0706q-.5673-.0359-1.1289-.0724t-1.1175-.0738q-.5559-.0375-1.1059-.0755a.7205.7205,0,0,0-.6028.3137.4558.4558,0,0,0-.04.5736q.4849.5525.95,1.1066t.9112,1.1079q.4457.5539.8714,1.1065t.8308,1.1022q.4051.55.79,1.0954t.7492,1.0861q.3645.54.7085,1.0744t.6681,1.06q.324.5262.6283,1.044t.5888,1.0255q.2846.5077.55,1.005t.5128.9822q.2472.4852.4763.9577t.4411.9312q.2119.4587.4073.9025t.3749.8723q.18.4285.344.84.2118.53.4086,1.0494t.3885,1.0319q.1915.5121.3824,1.0173t.3907,1.0057c.1333.3338.27.666.4134.9975s.2928.6622.451.9926.3249.6606.5029.9911.367.6614.57.9932.419.6646.6513.9987.4808.67.7476,1.0078.5521.678.8583,1.0207.6331.6881.9833,1.0369q.615.6126,1.2452,1.1632.6284.5511,1.2623,1.0427.6321.4923,1.26.9276.6264.4358,1.24.8174.6116.3822,1.2012.713c.3921.2207.775.4249,1.1457.6136s.7292.3618,1.073.52.6725.3024.9838.4327.6048.2469.8779.3508.5261.1956.756.2753.4365.1483.6172.2059.3357.1049.462.1425q.6727.2005,1.3225.3588t1.273.2792q.6232.1212,1.2184.2079t1.1587.1448q.5635.058,1.0938.09t1.0234.0433q.4934.0114.9476.0052t.866-.0247q.4137.0185.87.0248t.9524-.0049q.4956-.0114,1.0287-.0432t1.0992-.09q.5662-.058,1.1646-.1447t1.2244-.2077q.6264-.121,1.2792-.2792t1.3289-.3586c.1269-.0377.2827-.0848.4644-.1425s.3892-.126.62-.2058.4849-.1713.76-.2753.5693-.2206.882-.3508.6432-.2741.9884-.4326.7057-.3316,1.0782-.52.7571-.3928,1.1509-.6136.7974-.4582,1.207-.713.8259-.5269,1.2455-.8175.8427-.6,1.2661-.9276.8474-.6754,1.2684-1.0428.8391-.755,1.2512-1.1634q.5275-.5232.9877-1.0371t.8622-1.0207q.4022-.5068.7511-1.008t.6545-.9988q.3055-.4977.5725-.9933.2687-.4957.5055-.9913.2385-.4956.4533-.9926c.1441-.3315.2817-.6639.4155-.9977s.264-.6688.3928-1.0058.256-.6759.3846-1.0173.2577-.6852.3906-1.032.2691-.6965.4109-1.05q.1658-.4117.3462-.84t.3771-.8724q.1965-.4439.41-.9027t.4439-.9312q.2306-.4723.4792-.9577t.516-.9824q.2672-.4971.5537-1.005t.5926-1.0255q.3061-.5177.6321-1.0441t.6722-1.06q.3463-.5337.7132-1.0743t.7539-1.0861q.3873-.5455.7952-1.0953t.8363-1.1022q.4281-.5523.8767-1.1064t.9173-1.1076q.4686-.5541.9566-1.1064a.454.454,0,0,0-.039-.5736A.7251.7251,0,0,0,112.7182,252.0022Z"
      transform="translate(-35.9183 -224.122)"
    />
  </g>
  <g id="top">
    <path
      id="toppart"
      fill="url(#radial-gradient)"
      class="inner-bowl"
      d="M53.8308,254.7924c4.2253.3452,11.1126.799,19.989.8256,9.6723.0288,17.3109-.4629,22.3739-.8907,10.03-.8477,16.92-1.43,16.9437-2.3994.04-1.6353-19.4675-4.195-39.0473-4.1439-18.9508.0494-37.902,2.5447-37.8629,4.15C36.2523,253.3564,43.9779,253.9875,53.8308,254.7924Z"
      transform="translate(-35.9183 -224.122)"
    />
  </g>
  <g id="Snake">
    <g id="middle">
      <path
        class="snake-middle-section"
        fill="url(#snake-gradient-middle)"
        d="M63.6408,340.6747l4.4535-8.1427a36.0572,36.0572,0,0,1,4.8521-2.0708c2.7837-.9548,3.8241-.9457,7.9967-2.049,3.5173-.93,5.3051-1.4156,6.7327-2.4223a9.4226,9.4226,0,0,0,4.0171-5.26,8.5567,8.5567,0,0,0-.4-5.3929c-1.5147-3.3773-5.6529-5.5012-10.35-5.2468v7.8781a86.7442,86.7442,0,0,0-10.273,2.4986,22.6281,22.6281,0,0,0-5.0883,1.9726c-1.4459.8617-6.25,3.7247-6.6953,8.9425a10.7113,10.7113,0,0,0,2.8261,7.7844A9.51,9.51,0,0,0,63.6408,340.6747Z"
        transform="translate(-35.9183 -224.122)"
      />
    </g>
    <g id="bottom">
      <path
        class="snake-bottom-section"
        fill="url(#snake-gradient-bottom)"
        d="M94.2341,340.1852A13.3782,13.3782,0,0,0,89.216,337.25a23.0082,23.0082,0,0,0-5.6347-1.4509c1.5322,2.6621,3.0456,5.4705,4.5172,8.4273q.7188,1.4439,1.3912,2.8672a7.438,7.438,0,0,1-2.8354,1.8263c-8.1548,3.032-19.3083,4.536-29.996,4.9542-11.9606.468-18.0064-1.0826-18.1263-.3362-.1257.7828,6.381,2.6112,11.5754,3.54a73.0156,73.0156,0,0,0,11.6142,1.0253,106.6966,106.6966,0,0,0,14.5516-.9909c14.6343-1.8814,17.5737-4.8571,18.7538-6.391a8.0163,8.0163,0,0,0,1.965-5.5273A8.2943,8.2943,0,0,0,94.2341,340.1852Z"
        transform="translate(-35.9183 -224.122)"
      />
    </g>
    <g id="top-2">
      <path
        class="snake-top-section"
        fill="url(#snake-gradient-top)"
        d="M125.9123,240.6984c-7.664-16.9072-32.9572-22.4058-46.4859-9.3015-.0372.0236-.0752.045-.1118.07-1.3589.9316-3.4017,2.7977-3.8485,4.4357-.9223,3.3811.1923,6.2591-.0225,7.8385-.1376,1.0114-1.77,3.1-1.1562,3.9167a.9628.9628,0,0,0,.5579.3035,16.5317,16.5317,0,0,1-2.5646,1.8533l1.4455-.5135L73.549,250.35l1.7077-2.3223a13.847,13.847,0,0,0,3.418-.3693,31.8926,31.8926,0,0,0,7.4882-6.3563c1.9271-2.2383,2.1309-3.1193,3.0749-4.054,4.4607-4.4166,18.2322-2.8837,24.9317,4.8814,9.53,11.0462-.0305,29.1645-.9954,30.934-4.7232,8.6631-13.6639,13.67-15.8514,14.8685a29.4965,29.4965,0,0,1-2.8417,1.3849c-4.6073,1.9428-8.2864,2.1849-13.6474,2.4706a87.8816,87.8816,0,0,0-12.0477,1.0741c-4.4205.8669-8.4744,2.5958-11.6772,6.356-4.77,6.8057,2.43,14.4,8.8433,16.2635.9157.2952,1.8518.5414,2.8008.7574l.0152-10.712.002-1.476a23.6226,23.6226,0,0,1,3.47-.792c2.9439-.2432,5.8015-.4163,8.594-.633,9.5736-.7429,18.3738-2.0033,27.196-8.4015a52.8425,52.8425,0,0,0,16.2024-18.8092C126.5132,270.5782,132.7326,255.7444,125.9123,240.6984Z"
        transform="translate(-35.9183 -224.122)"
      />
    </g>
  </g>
  <g id="Eye">
    <g id="Eye-2">
      <path
        class="snake-eyes"
        d="M78.914,236.264l-.45.5239c-.0694.0809-.1269.1838-.0474.2815a.4256.4256,0,0,0,.3595.0966l.7138-.04a.7137.7137,0,0,0,.3364-.118c.0626-.0452.1645-.1228.1636-.2089l-.0114-1.1251a.1877.1877,0,0,0-.0981-.1866.5071.5071,0,0,0-.2981-.0469.7365.7365,0,0,0-.3365.118c-.0626.0452-.1644.1228-.1636.2089l.0114,1.1251.5-.3269-.7137.04.3121.378.45-.524a.2465.2465,0,0,0,.0817-.2172.2411.2411,0,0,0-.1793-.1472.6554.6554,0,0,0-.3354.0089.6174.6174,0,0,0-.295.16Z"
        transform="translate(-35.9183 -224.122)"
      />
    </g>
  </g>
</svg>
<h1 *ngIf="showTitle" class="brand__title">Elder Drug</h1>
